// extracted by mini-css-extract-plugin
module.exports = {"lazyImage":"JRU0urF","silver":"_2hPCTVi","darkGrey":"_2f0wY7v"};